import directives from './module';
import {HttpSvcFactory} from '../services/HttpSvc';
import {AnimatronProjects, AnimatronProjectsFactory} from '../services/AnimatronProjectsSvc';
import {FollowersSvc} from "../services/FollowersSvc";
import {MyFollowings} from "../services/MyFollowings";
import {Utils} from 'underscore-extensions';

type PopupPosition = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

class UserPopup {
    private static userCache: {[user: string]: anm.User} = {};

    private static PopupWidth = 400 + 50; //50 is offset
    private static PopupHeight = 245 + 50; //50 is offset

    user: anm.User;
    size: number;
    avatarOnly: boolean;
    disableBottom: boolean;

    followersSvc: FollowersSvc;
    loading: boolean;
    loaded: boolean;
    shown: boolean;

    showTimer: ng.IPromise<any>;
    hideTimer: ng.IPromise<any>;

    position: PopupPosition;

    constructor(private $scope: ng.IScope,
                private $filter: ng.IFilterService,
                private $timeout: ng.ITimeoutService,
                private $q: ng.IQService,
                private HttpSvc: HttpSvcFactory,
                private AnimatronProjects: AnimatronProjectsFactory,
                private MyFollowings: MyFollowings) {
        this.size = this.size || 20;
    }

    public show(e: MouseEvent) {
        this.load();
        if (this.shown) {
            this.$timeout.cancel(this.hideTimer); //the case when user hovers on popup-opener before animation ends(300ms)
        } else {
            this.pickPosition(e);
        }
        this.showTimer = this.$timeout(() => this.shown = true, 500);
    }

    public hide() {
        this.$timeout.cancel(this.showTimer);
        this.hideTimer = this.$timeout(() => this.shown = false, 300); //transition duration
    }

    private pickPosition(e: MouseEvent) {
        Utils.rAF(() => {
            const scrollY  = window.scrollY || document.documentElement.scrollTop;
            const topLeft  = e.pageX + UserPopup.PopupWidth > window.innerWidth;
            const topRight = e.pageY + UserPopup.PopupHeight > (scrollY + window.innerHeight);

            if (topLeft && topRight) {
                this.position = 'top-left';
            } else if (topRight || this.disableBottom) {
                this.position = 'top-right';
            } else if (!topLeft && !topRight) {
                this.position = 'bottom-right';
            } else {
                this.position = 'bottom-left';
            }
            this.$scope.$apply();
        });
    }

    private load = _.once(() => {
        this.loaded = true;
        const username = this.$filter('encodeUsername')(this.user.username);

        if (UserPopup.userCache[this.user.username]) {
            this.user = UserPopup.userCache[this.user.username];
        } else {
            this.fetchAndCacheInfo(username);
        }

        this.MyFollowings.init().then(svc => this.followersSvc = svc);
    });

    private fetchAndCacheInfo(username: string): void {
        this.loading = true;
        this.$q.all([
            new this.AnimatronProjects({username, limit: 3, sortBy: 'views'}).nextPage(),
            this.HttpSvc<anm.User>(username, 'profile').get()
        ]).then(([prj, usr]) => {
            this.loading = false;
            this.user = usr.data;
            this.user.projects = prj.results;
            this.user.projectsCount = prj.count;
            UserPopup.userCache[this.user.username] = this.user;
        });
    }
}

directives.component('userPopup', {
        bindings: {
            size: '<',
            user: '<',
            avatarOnly: '<',
            disableBottom: '<'
        },
        controller: UserPopup,
        templateUrl: require('user-popup.html')
    }
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/UserPopup.ts